import {
  MarketplaceInstallationsDocument,
  MarketplaceInstallationsQuery,
  MarketplaceInstallationsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type MarketplaceInstallationsData =
  MarketplaceInstallationsQuery['marketplace']['companyInstallationsConnection']['nodes'][number]

export const useGetMarketplaceInstallations = (
  variables: MarketplaceInstallationsQueryVariables
) => {
  const { loading, data, refetch } = useQuery(MarketplaceInstallationsDocument, { variables })
  const installationsData = data?.marketplace.companyInstallationsConnection.nodes ?? []

  return {
    loading,
    data: installationsData,
    refetch,
  }
}
